<ui-block width="1x">
  <ui-outlined-input-group
    label="My Stuff"
    width="full"
    outsideColor="#f9f9fe"
    insideColor="white">
  <div>My stuff here</div>
  </ui-outlined-input-group>
</ui-block>
